import React from "react";
import InsightsDashboard from "../components/Dashboard/InsightsDashboard";
import "./layout.css";

const Insights = () => {
    return (
        <div className="page-container">
            <div className="pt-4">
                <InsightsDashboard />
            </div>
        </div>
       
    );
};

export default Insights;
